import { FC, ReactNode, useMemo } from 'react';
import cx from 'classnames';

import { SvgIcon } from '@/components';
import { getRiskTypeByValue } from '@/helpers';

import styles from './RiskBadge.module.sass';

interface RiskBadgeProps {
  value: number;
  note?: ReactNode;
  className?: string;
  comparison?: string;
}

const RiskBadge: FC<RiskBadgeProps> = ({
  value,
  note,
  className,
  comparison = '',
}) => {
  const riskType = useMemo(
    () => getRiskTypeByValue(value, comparison),
    [value],
  );

  const classes = cx(styles.risk, styles[`risk--${riskType}`], className);

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <SvgIcon name="risk" className={styles.icon} />
        <span className={styles.label}>
          {comparison}
          &nbsp;
          {value}%
        </span>
      </div>
      {note && <div className={styles.note}>{note}</div>}
    </div>
  );
};

export default RiskBadge;
